<template>
  <div
    ref="container"
    class="container-fluid"
  >
    <navbar :title="$t('menu.calendar')" />

    <div class="col-12 nopads mt-2">
      <!-- Tabs -->
      <ul class="nav nav-tabs routa-tabs">
        <li class="nav-item routa-tab-nav-item">
          <button
            class="routa-tab"
            :class="{ active: activeTab === 1 }"
            @click="activeTab = 1"
          >
            {{ $t('menu.contracts') }}
          </button>
        </li>
        <li class="nav-item">
          <button
            class="routa-tab"
            :class="{ active: activeTab === 2 }"
            @click="activeTab = 2"
          >
            {{ $t('menu.fleet') }}
          </button>
        </li>
      </ul>
      <!-- Content -->
      <div class="tab-content routa-tab-content">
        <div
          class="tab-pane fade"
          :class="{ show: activeTab === 1, active: activeTab === 1 }"
        >
          <contract-calendar :user="user" />
        </div>
        <div
          class="tab-pane fade"
          :class="{ show: activeTab === 2, active: activeTab === 2 }"
        >
          <vehicle-calendar :user="user" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractCalendar from "@/components/contractcalendar/ContractCalendar";
import VehicleCalendar from "@/components/vehicle/calendar/VehicleCalendar";
import Navbar from "@/components/utils/Navbar.vue";

export default {
    name: 'ContractCalendarContainer',
    components: {Navbar, ContractCalendar, VehicleCalendar},
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            activeTab: 1,
        }
    }
}
</script>
